(()=>{
 function init(scope=document){
  scope.querySelectorAll('[data-scr-finder]').forEach(root=>{
   if(root.dataset.ready)return;root.dataset.ready='true';
   const panels=[...root.querySelectorAll('[data-scr-panel]')],buttons=[...root.querySelectorAll('[data-scr-taste]')];
   function category(button){
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    panels.forEach(p=>p.hidden=p.dataset.scrCategory!==button.dataset.scrTaste);
   }
   buttons.forEach(button=>button.addEventListener('click',()=>category(button)));
   if(buttons[0])category(buttons[0]);
   root.addEventListener('shopify:block:select',e=>{
    const panel=panels.find(p=>p.dataset.scrPanel===e.detail.blockId);
    const button=panel&&buttons.find(b=>b.dataset.scrTaste===panel.dataset.scrCategory);
    if(button)category(button);
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 if(!window.scrGrowthEditorListener){document.addEventListener('shopify:section:load',e=>init(e.target));window.scrGrowthEditorListener=true;}
})();
